import { Routes, Route, Navigate } from 'react-router-dom';
import MobileLayout from '@/layouts/MobileLayout';
import LoginPage from '@/pages/LoginPage';
import Home from '@/pages/Home';
import TaskPool from '@/pages/TaskPool';
import NodeTaskPage from '@/pages/NodeTaskPage';
import LoadNodePage from '@/pages/LoadNodePage';
import Messages from '@/pages/Messages';
import Me from '@/pages/Me';

export default function AppRouter() {
  return (
    <Routes>
      {/* 登录页（无 Layout） */}
      <Route path="/mobile/login" element={<LoginPage />} />

      {/* 业务页面（有 Layout） */}
      <Route element={<MobileLayout />}>
        {/* 首页：今日作业工作台 */}
        <Route path="/mobile/home" element={<Home />} />
        {/* 任务中心：全量任务（待处理/进行中/已完成） */}
        <Route path="/mobile/tasks" element={<TaskPool />} />
        {/* 通用节点作业页（按 orderId 处理任意履约节点的作业） */}
        <Route path="/mobile/task/:orderId" element={<NodeTaskPage />} />
        {/* 装柜节点专用页（IoT 绑定 + 封柜确认 + 拍照取证） */}
        <Route path="/mobile/load/:orderId" element={<LoadNodePage />} />
        {/* 消息中心 / 个人中心（T6） */}
        <Route path="/mobile/messages" element={<Messages />} />
        <Route path="/mobile/me" element={<Me />} />
      </Route>

      {/* 已登录根路径重定向到首页工作台 */}
      <Route path="/mobile" element={<Navigate to="/mobile/home" replace />} />
      {/* 默认跳转登录 */}
      <Route path="*" element={<Navigate to="/mobile/login" replace />} />
    </Routes>
  );
}
